import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useThemeComponents } from '../../../../themes';
import useCompanyFormats from '../../../../utilities/useCompanyFormats';
import { type GiftVoucherKYCJourneyValues } from './KYCPage/shared';

const StyledContainer = styled.div`
    background-color: #eff0f1;
    padding: 15px;

    .ant-form-item-label > label {
        color: rgba(0, 0, 0, 0.85);
    }

    ul li {
        font-size: 16px;
    }
`;
const GiftVoucherAmount = () => {
    const { t } = useTranslation('giftVoucherJourney');
    const {
        FormFields: { DisplayField },
    } = useThemeComponents();
    const { formatAmountWithCurrency } = useCompanyFormats();

    const { values } = useFormikContext<GiftVoucherKYCJourneyValues>();
    const amount = useMemo(
        () => values.value * values.numberOfBookingReferenceDays,
        [values.numberOfBookingReferenceDays, values.value]
    );

    return (
        <StyledContainer>
            <DisplayField
                label={t('giftVoucherJourney:journey.amount.title')}
                value={formatAmountWithCurrency(amount)}
            />
            <ul>
                <li>{t('giftVoucherJourney:journey.amount.firstDescription')}</li>
                <li>{t('giftVoucherJourney:journey.amount.secondDescription')}</li>
                <li>{t('giftVoucherJourney:journey.amount.thirdDescription')}</li>
                <li>{t('giftVoucherJourney:journey.amount.forthDescription')}</li>
            </ul>
        </StyledContainer>
    );
};
export default GiftVoucherAmount;
